import {useGetInstanceInfo} from '../../../core/use-get-instance-info';

export const useHasFullSchedulerAccess = (): {
    isLoading: boolean;
    hasFullSchedulerAccess: boolean;
} => {
    const {sessionInstance, isLoading} = useGetInstanceInfo();

    const hasFullSchedulerAccess = sessionInstance
        ? sessionInstance.schedulerAccessType === 'FULL_ACCESS'
        : false;

    return {
        isLoading,
        hasFullSchedulerAccess,
    };
};
